/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CrossOrgProcessedSubscriptionResponse { 
    id?: number;
    charge_id?: string;
    created_ts?: Date;
    data_center?: string;
    effective_date?: string;
    quantity?: number;
    uom?: string;
    updated_ts?: Date;
}

